import { FileUploadState } from "./types";

const state: FileUploadState = {
  storageType: "azure",
};

export default state;
